import { ISessionFilter } from '../../../shared/interfaces';

export const saveFilter = (data: ISessionFilter) => {
  const filter = { ...data };
  sessionStorage.setItem('financial-filter', JSON.stringify(filter));
};

export const getFilter = (): ISessionFilter | null => {
  const filter: string | null = sessionStorage.getItem('financial-filter');
  if (filter) {
    return JSON.parse(filter);
  }
  return null;
};

export const deleteFilter = (): void => {
  sessionStorage.removeItem('financial-filter');
};
